"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";
import QueryString from "qs";

const logisticTripsService = {
  getLogisticTrips: function (options) {
    return api.get(
      "/Trips",
      WithToken.headersToken(
        {
          params: options,
          paramsSerializer: (params) => {
            return QueryString.stringify(params);
          },
        },
        configuration.cookieName
      )
    );
  },
  getLogisticTrip: function (options) {
    return api.get("/Trips/" + options.id, WithToken.headersToken({ params: {} }, configuration.cookieName));
  },
  createLogisticTrip: function (options) {
    return api.post(`/Trips`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteLogisticTrip: function (options) {
    return api.delete(`/Trips`, WithToken.headersToken({ params: { id: options.id } }, configuration.cookieName));
  },
  updateLogisticTrip: function (options) {
    return api.put(`/Trips/${options.id}`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  copyLogisticTrip: function (options) {
    return api.post(`/Trips/${options.id}/Copy`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  updateLogisticTripAlarm: function (id, options) {
    return api.put(`/Trips/${id}/Alarm`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  getLogisticTripGeoJson: function (options) {
    return api.get(`/Trips/${options.id}/GeoJson`, WithToken.headersToken({ params: {} }, configuration.cookieName));
  },
  addLogisticTripUnit: function (options) {
    return api.post(`/TripUnits`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteLogisticTripUnit: function (options) {
    return api.delete(`/TripUnits`, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
};

export default logisticTripsService;
